import React, {useState, useEffect, useCallback} from 'react'
import { connect } from 'react-redux'
import {bindActionCreators} from "redux";
import Parser from 'html-react-parser';
import {delCartItem, checkCartItem, updateCartItemQuantity} from '../actions/nCartAppActions';
import {NLoader} from './NLoader'
import debounceFunc from '../utils/debounce'
import formattedPrice from '../utils/formattedPrice'


const NCartProduct  = props => {

    const {item, index, delCartItem, checkCartItem, updateCartItemQuantity} = props;
    const extra_price_default = item.total === item.subtotal ? 0 : item.subtotal;
    const extra_price = !item.checked ? item.total: extra_price_default;
    const real_step = item.unit_step ? parseFloat(item.unit_step): 1.0;
    const real_quantity = item.quantity * real_step;

    const [isFetching, setFetching] = useState(false);
    const [quantityValue, setQuantityValue] = useState(real_quantity);

    const plus_enabled = (isFetching || !item.checked || (item.quantity >= item.summary.max_quantity)) ? false : true
    const minus_enabled = (isFetching || !item.checked || (item.quantity === 1)) ? false : true
    const quantity_enabled = isFetching || !item.checked ? false : true

    const no_img = "https://www.tdpra.ru/static/shop_backbone/images/noimage.png"

    function updateQuantity(item, quantity){

        setFetching(true);
        updateCartItemQuantity(item, quantity);
    }

    const debounceUpdateQuantity = useCallback(
        debounceFunc(updateQuantity, 600)
    , []);


    const handleRemove = (e, item_id) => {
        setFetching(true);
        delCartItem(item_id);
    };

    const handleChangeChecked = e => {

        setFetching(true);
        checkCartItem(item.id, !item.checked);

    };

    const handleDaltaQuantity = (e, delta) => {

        let c_quantity = prepareQuantity(quantityValue) + delta;
        let c_real_quantity =  real_step * c_quantity;

        if (delta > 0){
            // increment
            if (item.summary.max_quantity >= c_quantity){

                debounceUpdateQuantity(item, c_quantity);
                setQuantityValue(c_real_quantity);

            }
        }else if (c_quantity >= 1){

            debounceUpdateQuantity(item, c_quantity);
            setQuantityValue(c_real_quantity);
        }

    };

    const prepareQuantity = quantity => {

        let unit_step = item.unit_step ? parseFloat(item.unit_step): 1.0;
        let result = unit_step;
        quantity = quantity ? quantity: unit_step;

        if (unit_step===1.0){
            result = parseInt(quantity);
        }else{
            result = Math.trunc(parseFloat(quantity) / unit_step);
        }

        return result
    }

    const handleChangeQuantity = real_quantity => {

        if (real_quantity.includes(",")){
            real_quantity = real_quantity.replace(",", ".")
        }

        setQuantityValue(parseFloat(real_quantity)||'');
    };


    const handleApplayQuantity = e => {

        let c_quantity = prepareQuantity(quantityValue);
        let unit_step = item.unit_step ? parseFloat(item.unit_step): 1.0;

        if (c_quantity < 1 ){
            c_quantity = 1;
        }else if (c_quantity > item.summary.max_quantity){
            c_quantity = item.summary.max_quantity
        }
        let c_real_quantity =  unit_step * c_quantity;


        if (c_real_quantity.toString() !== quantityValue.toString()){

            setQuantityValue(c_real_quantity);
        }

        if (c_quantity !== item.quantity){
            setFetching(true);
            updateCartItemQuantity(item, c_quantity);
        }

    };

    useEffect(() => {
        let new_quantity = real_step * item.quantity
        setQuantityValue(new_quantity);
        setFetching(false);

    }, [item.updated_at]);


    return (
        <div className={`row ncart-product${item.checked ? '': ' product-disabled'}`} key={index}>
          <div className="col-sm-2 col-xs-3">
              <div className="ncart-checked-button">
                  <input type="checkbox" id={`ncart-product-check-${index}`}
                         className="ncart-checkbox filled-in"
                         checked={item.checked ? 1 : 0}
                         onChange={e => handleChangeChecked(e)}/>
                  <label htmlFor={`ncart-product-check-${index}`}></label>
              </div>
              <div className="ncart-image">
                  <a href={item.summary.link ? item.summary.link : '#'}>
                      <img className="img-responsive" src={item.image ? item.image : no_img}/>
                  </a>
              </div>
          </div>

          <div className="col-sm-7 col-xs-9">
              <h4 className="ncart-item-heading">
                  <span className="ncart-art-heading">Артикл: </span> <span>{item.summary.art}</span>
                  {item.extra_rows && item.extra_rows.map((extra_row, e_index) => (
                      <span className="ncart-discount-heading" key={e_index}>{extra_row.title} <span>({extra_row.amount}&nbsp;&#8381;)</span></span>
                    ))
                  }
              </h4>
              <h4 className="ncart-item-title">
                  <a href={item.summary.link ? item.summary.link : '#'}>{item.title}</a>
              </h4>
              <div className="ncart-item-description">
                  {Parser(item.summary.html)}
              </div>
          </div>

          <div className="col-sm-3">

              <div className="ncart-extra-price">
                  <span className="ncart-extra-price-padding">
                      &nbsp;
                  </span>
                  { extra_price ?
                      <span className="ncart-extra-price-value">{ formattedPrice(extra_price) }&nbsp;&#8381;</span>
                      :
                      <span className="noline"></span>
                  }
                <span className="delete-control" onClick={e => handleRemove(e, item.id)}>
                      <i className="material-icons">close</i>
                  </span>
              </div>

              <div className="ncart-item-price">
                  {isFetching ?
                      <NLoader/>
                      :
                      <span className="price">{item.checked ? formattedPrice(item.total) : 0}&nbsp;&#8381;</span>
                  }
              </div>
              <div className="ncart-item-quantity">
                  { minus_enabled ?
                      <div className="nquantity-control nquantity-down" onClick={e => handleDaltaQuantity(e, -1)}>
                        <i className="material-icons">remove</i>
                      </div>
                      :
                      <div className="nquantity-control nquantity-down disabled">
                        <i className="material-icons">remove</i>
                      </div>
                  }
                  { quantity_enabled ?
                      <div className="ncart-form-line">
                          <input type="text"
                                 className="ncart-form-control"
                                 onBlur={e => handleApplayQuantity(e)}
                                 onChange={e => handleChangeQuantity(e.currentTarget.value)}
                                 onKeyDown={e => e.key === 'Enter' && handleApplayQuantity(e)}
                                 value={quantityValue}/>
                      </div>

                      :

                      <div className="ncart-form-line">
                          <input type="text" className="ncart-form-control disabled" value={quantityValue} readOnly={true}/>
                      </div>
                  }

                  {plus_enabled ?
                      <div className="nquantity-control nquantity-up" onClick={e => handleDaltaQuantity(e, 1)}>
                          <i className="material-icons">add</i>
                      </div>
                      :
                      <div className="nquantity-control nquantity-up disabled">
                          <i className="material-icons">add</i>
                      </div>
                  }
              </div>
              <div className="ncart-item-unit">{item.unit}</div>
          </div>
      </div>
)}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => bindActionCreators({ delCartItem, checkCartItem, updateCartItemQuantity}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NCartProduct)
